import { Base2Presenter } from "core/presenter";
import Moment from "moment";

class AccountantInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      certificateStatus: "absent",
      company: {}
    };
  }

  onChangeProps() {
    const { certificate_info, fiscal_informations } = this.props.company;

    const hasCertificate =
      !!certificate_info &&
      !!certificate_info.uploaded_at &&
      !!certificate_info.expiry_date;
    const hasValidCertificate =
      hasCertificate && Moment(certificate_info.expiry_date).isAfter(Moment());

    if (hasCertificate && !fiscal_informations.certificate) {
      this.enqueue({
        certificateStatus: hasValidCertificate ? "valid" : "invalid"
      });
    } else if (!hasCertificate && fiscal_informations.certificate) {
      this.enqueue({ certificateStatus: "uploaded" });
    } else if (hasCertificate && fiscal_informations.certificate) {
      this.enqueue({ certificateStatus: "uploaded" });
    } else {
      this.enqueue({ certificateStatus: "absent" });
    }
  }

  onSelectCertificate(file) {
    const fileReader = new FileReader();
    fileReader.readAsBinaryString(file);
    fileReader.onload = event => this.parseFileContent(event.target.result);
  }

  parseFileContent(content) {
    let contentEncoded;

    try {
      contentEncoded = window.btoa(content);
      this.props.onChange("certificate", contentEncoded);
      this.enqueue({ certificateStatus: "uploaded" });
    } catch (e) {
      this.enqueue({ certificateStatus: "invalid" });
    }
  }
}

export default AccountantInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/accountant-info/presenter.js